
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import LinearProgress, {linearProgressClasses,} from "@mui/material/LinearProgress";
import React from "react";

const BorderLinearProgress = styled(LinearProgress)(({ theme, value }) => ({
    borderRadius: "50px",
    width: '90%',
    boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.15)",
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#F3F3F3",
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: "50px",
        background: (value > 20) ? "#1AACAC" : "#FD5E48"
    },
}));

export default function LinearProgressWithLabel({ value }) {
    return (
        <Stack spacing={2} sx={{ flexGrow: 1 }}>
            <BorderLinearProgress
                variant="determinate"
                value={value}
                sx={{ height: "20px" }}
            />
        </Stack>
    );
}